// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__nWCSa","invalid":"Checkbox_invalid__J4-a8"};